export default __webpack_public_path__ + "static/media/global-health-logo.b9f772b9.png";